module.exports = __webpack_public_path__ + "img/video809.c9d83d3b.jpg";